import { Pro } from '../industry/Pro';
import { Artist } from '../industry/Artist';
import { Series } from './Series';
import { Company } from '../industry/Company';
import { User } from '../auth/User';
import { Category } from './Category';
import { DeckVariation } from './DeckVariation';
import { Technology } from './Technology';

export class Deck {

	public id: string;
	public slug: string;
	public name: string;
	public year?: number;
	public notes: string;
	public version: string;
	public description: string;
	public numberOfPlys?: number;
	public length?: number;
	public tailLength?: number;
	public noseLength?: number;
	public width?: number;
	public wheelBase?: number;
	public totalRun?: number;
	public setNumber?: number;
	public setTotal?: number;
	public seasonId: number;
	public aosId: number;
	public sizeId: number;
	public shapeId: number;
	public surfaceId: number;
	public truckMountId: number;
	public isApproxYear: boolean;
	public isEnabled: boolean;
	public isReissue: boolean;
	public isFavorite: boolean;
	public knownFakes: boolean;
	public guestBoard: boolean;
	public limitedEdition: boolean;
	public selected: boolean = false;
	public visible: boolean = true;
	public createdBy: User;
	public lastUpdatedBy: User;
	public createdDate: string;
	public updatedDate: string;
	public series: Series[];
	public pros: Pro[];
	public artists: Artist[];
	public companies: Company[];
	public categories: Category[];
	public variations: DeckVariation[];
	public technologies: Technology[];

	constructor(init?: Partial<Deck>) {
		Object.assign(this, init);
	}
}
